import SmartListComponent from './SmartListComponent';
import { initialState, listReducer, filterReducer, initialFilter } from './reducer';

export {
    initialState,
    listReducer,
    initialFilter,
    filterReducer,
};

export default SmartListComponent;



// WEBPACK FOOTER //
// ./src/sections/SmartList/index.ts